// frontend/src/utils/withAuth.jsx

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * withAuth HOC
 * Wrap any component that should only be visible when the user is logged in.
 * It checks for a "token" in localStorage; if missing, redirects to /auth.
 */
const withAuth = (WrappedComponent) => {
  const AuthComponent = (props) => {
    const navigate = useNavigate();

    useEffect(() => {
      const token = localStorage.getItem("token");
      if (!token) {
        // user not logged in → go to /auth
        navigate("/auth", { replace: true });
      }
    }, [navigate]);

    return <WrappedComponent {...props} />;
  };

  return AuthComponent;
};

export default withAuth;
